import PropTypes from 'prop-types';
import React from 'react';

class MapMarker extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showInfo: props.selected };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.selected !== nextProps.selected) {
      this.setState({ showInfo: nextProps.selected });
    }
  }
  onMouseEnter = () => {
    this.setState({ showInfo: true });
  }

  onMouseLeave = () => {
    this.setState({ showInfo: false });
  }
  onClick = () => {
    this.props.onSelect(this.props.hotel.id);
  }

  render() {
    const style = { color: 'black' };
    if (this.props.selected) {
      style.color = 'red';
    }

    let icon = (
      <span className="fa-stack fa-lg" style={style}>
        <i className="fa fa-square fa-stack-2x" />
        <i className="fa fa-stack-1x fa-map-marker fa-inverse" />
      </span>
    );
    let name = 'unknown';
    if (this.props.hotel) {
      name = this.props.hotel.name;

      icon = (
        <span className="fa-stack fa-lg" style={style}>
          <i className="fa fa-square fa-stack-2x" />
          <i className="fa fa-stack-1x fa-hotel fa-inverse" />
        </span>);
    } else {
      name = this.props.name;
    }

    return (
      <div>
        <div
          style={{
            color: '#F00',
            width: 200,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          onClick={this.onClick}
        >
          {icon} {name}
        </div>
        {this.state.showInfo &&
          <div
            style={{
              backgroundColor: '#3d4461',
              border: '1px solid #777',
              color: '#FFF',
              width: 160,
              height: 100,
              padding: 10,
              position: 'relative',
              zIndex: 9999,
            }}
          >
            <h5 style={{ margin: 0 }}>{name}</h5>
            <p style={{ margin: 0 }}>{this.props.hotel.address}</p>
            <p style={{ margin: 0 }}>{this.props.hotel.locality}, {this.props.hotel.region}</p>
          </div>
        }
      </div>
    );
  }
}

MapMarker.propTypes = {
  hotel: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default MapMarker;


// WEBPACK FOOTER //
// src/routes/hotels/components/MapMarker.js